/* FleetPro RETAIL — hero finder behaviour: tab switching + VIN decode.
   VIN v2 (2026-07-06): decoding goes through FPVIN (fp-vin-resolver.js +
   fp-vin-maps.json, section passes the asset URL via data-fp-vin-maps) —
   truck+engine chips, at most ONE open question, honesty notes for
   offline/not-mapped/BEV (mockup frames 1-2). Falls back to the legacy
   direct-vPIC fill when the resolver is unavailable.
   2026-07-08: the same input also takes OEM part numbers (>=5 chars with a
   digit) — exact cross lookup in fp-oem-index.json (data-fp-oem-index on the
   section root), same routing rules as sections/fp-vin-search.liquid.
   Liquid-free, multi-instance. Each .fp-hero root is initialised once. */
(function () {
  function injectCss() {
    if (document.getElementById('fp-fill-css')) return;
    var s = document.createElement('style');
    s.id = 'fp-fill-css';
    s.textContent =
      '.fp-hero .fp-ymm .fp-fill-anim{animation:fpFill .85s ease}' +
      '@keyframes fpFill{0%{box-shadow:0 0 0 0 rgba(111,157,245,0);transform:scale(1)}22%{box-shadow:0 0 0 3px rgba(111,157,245,.6);transform:scale(1.02)}100%{box-shadow:0 0 0 0 rgba(111,157,245,0);transform:scale(1)}}' +
      '.fp-hero .fp-finder__summary{display:flex;align-items:center;gap:9px;flex-wrap:wrap;margin:0 0 14px;padding:10px 13px;background:rgba(111,157,245,.12);border:1px solid rgba(111,157,245,.35);border-radius:8px;font-size:13px;color:#fff;line-height:1.3;animation:fpFill .5s ease}' +
      '.fp-hero .fp-finder__summary[hidden]{display:none}' +
      '.fp-hero .fp-finder__summary svg{width:16px;height:16px;flex:none;fill:none;stroke:#6F9DF5;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}' +
      '.fp-hero .fp-finder__summary b{font-weight:800}' +
      '.fp-hero .fp-sum__vin{color:#9fb0c4;font-size:12px}' +
      '.fp-hero .fp-sum__vin code{color:#cfe0ff;background:rgba(255,255,255,.1);padding:1px 6px;border-radius:4px;letter-spacing:.04em}' +
      '.fp-hero .fp-vin-cta{margin-top:10px;width:100%}' +
      '.fp-hero .fp-oemhit{display:block;background:#fff;border:1px solid #E3E8EF;border-radius:10px;padding:11px 13px;margin-top:9px;text-decoration:none;transition:border-color .15s}' +
      '.fp-hero .fp-oemhit:hover{border-color:#6F9DF5}' +
      '.fp-hero .fp-oemhit b{display:block;font-size:14px;color:#0B1E3F}' +
      '.fp-hero .fp-oemhit__sku{display:block;font:500 12px/1.4 "Roboto Mono",ui-monospace,Menlo,Consolas,monospace;color:#5A6675;margin-top:2px}' +
      '.fp-hero .fp-oemhit__x{display:block;font-size:12px;color:#5A6675;margin-top:4px}';
    document.head.appendChild(s);
  }
  function flash(el) {
    if (!el) return;
    el.classList.remove('fp-fill-anim');
    void el.offsetWidth;
    el.classList.add('fp-fill-anim');
  }
  function esc(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function engineShort(engine) {
    if (!engine) return '';
    if (!engine.parent) return engine.other || '';
    return String(engine.parent).split(' ').pop();
  }
  /* JS port of fitlib.normalize_oem — keep in sync with fitlib._OEM_BRANDS
     and the copy inside sections/fp-vin-search.liquid */
  /* The brand vocabulary now travels INSIDE fp-oem-index.json (`brands`), built
     by scripts/build_oem_index.py from fitlib. Nothing to keep in sync any more:
     the hand-copied list here and fitlib's agreed with each other perfectly and
     both were blind to 46% of the catalog — Cummins, Gates, Parker, Tectran,
     Hendrickson, Eaton and Firestone numbers were indexed under keys no customer
     would ever type. The literal below is only the fallback for an index served
     from cache before the field existed. */
  var OEM_BRANDS = /^(volvo|freightliner|kenworth|peterbilt|mack|paccar|navistar|international|detroit(\s+diesel)?|grote|truck[- ]?lite|trucklite|bendix|haldex|meritor|wabco|dorman|automann|united\s+pacific|newstar|s&s|alliance|abp)\s+/i;
  /* MOVED to assets/fp-oem-lookup.js. These two delegate rather than duplicate:
     the header search needed the same normalizer, and a third hand-copy is
     precisely the bug this file's comment above describes — copies that agree
     with each other and are all wrong together. The local branches below only
     run if that asset failed to load, in which case the hero degrades to its
     old fallback-regex behaviour instead of throwing. */
  function brandRe(list) {
    if (window.FPOEM) return window.FPOEM.brandRe(list);
    if (!list || !list.length) return OEM_BRANDS;
    var alts = list.map(function (b) {
      return b.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\s+/g, '\\s+');
    }).sort(function (a, b) { return b.length - a.length; });
    try { return new RegExp('^(' + alts.join('|') + ')\\s+', 'i'); } catch (e) { return OEM_BRANDS; }
  }
  function normOem(s, re) {
    if (window.FPOEM) return window.FPOEM.normOem(s, re);
    return String(s || '').trim().replace(re || OEM_BRANDS, '').replace(/[^A-Za-z0-9]/g, '').toUpperCase();
  }

  function initHero(root) {
    if (!root || root.dataset.fpInit) return;
    root.dataset.fpInit = '1';

    var tabs = root.querySelectorAll('.fp-finder__tabs .fp-tab');
    var panes = root.querySelectorAll('.fp-pane');
    function show(p) {
      tabs.forEach(function (b) { var on = b.getAttribute('data-pane') === p; b.classList.toggle('on', on); b.setAttribute('aria-selected', on); });
      panes.forEach(function (x) { var on = x.getAttribute('data-pane') === p; x.classList.toggle('on', on); x.hidden = !on; });
    }
    tabs.forEach(function (b) { b.addEventListener('click', function () { show(b.getAttribute('data-pane')); }); });
    root.querySelectorAll('[data-go]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); show(a.getAttribute('data-go')); });
    });

    var vinInput = root.querySelector('.fp-vin-input');
    var vinBtn = root.querySelector('.fp-vin-go');
    var vinStatus = root.querySelector('.fp-vin-status');
    var chipsEl = root.querySelector('[data-fp-vin-chips]');
    var extraEl = root.querySelector('[data-fp-vin-questions]');
    function setStatus(msg, type) { if (!vinStatus) return; vinStatus.textContent = msg || ''; vinStatus.className = 'fp-vin-status' + (type ? ' is-' + type : ''); }
    function titleCase(s) { return (s || '').toString().toLowerCase().replace(/\b[a-z]/g, function (c) { return c.toUpperCase(); }); }
    function clearVinUi() { if (chipsEl) chipsEl.innerHTML = ''; if (extraEl) extraEl.innerHTML = ''; }

    // Search summary bar (top of the finder): which truck + VIN we're searching
    var lastVin = '';
    var ymmMount = root.querySelector('.fp-ymm');
    var fbody = root.querySelector('.fp-finder__body');
    var summaryEl = null;
    if (fbody) {
      summaryEl = document.createElement('div');
      summaryEl.className = 'fp-finder__summary';
      summaryEl.hidden = true;
      fbody.insertBefore(summaryEl, fbody.firstChild);
    }
    function buildTruck() {
      if (!ymmMount) return '';
      var parts = [];
      Array.prototype.forEach.call(ymmMount.querySelectorAll('select'), function (s) {
        if (s.selectedIndex > 0 && s.value) { var o = s.options[s.selectedIndex]; if (o && o.text) parts.push(o.text.trim()); }
      });
      return parts.join(' ');
    }
    function setSummary(truck) {
      if (!summaryEl) return;
      truck = (truck || '').trim();
      if (!truck && !lastVin) { summaryEl.hidden = true; return; }
      var html = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h11v9H3zM14 9h4l3 3v3h-7"/><circle cx="7" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/></svg>';
      html += '<span class="fp-sum__truck">Searching: <b>' + (esc(truck) || 'your truck') + '</b></span>';
      if (lastVin) { html += '<span class="fp-sum__vin">VIN <code>' + esc(lastVin) + '</code></span>'; }
      summaryEl.innerHTML = html;
      summaryEl.hidden = false;
    }
    function rememberTruck() {
      var truck = buildTruck();
      if (!truck) return;
      try {
        sessionStorage.setItem('fp_pending_truck', JSON.stringify({ label: truck, ts: Date.now() }));
      } catch (e) {}
    }
    if (ymmMount) {
      ymmMount.addEventListener('change', function () { setSummary(buildTruck()); });
      ymmMount.addEventListener('submit', rememberTruck, true);
      ymmMount.addEventListener('click', function (e) {
        var t = e.target && e.target.closest && e.target.closest('button,a,input[type="submit"]');
        if (t) rememberTruck();
      }, true);
    }

    /* ---------- VIN v2 UI (chips / one question / notes / CTA) ---------- */
    function chip(main, sub, isEngine, tick) {
      var c = el('span', 'fp-vinchip' + (isEngine ? ' fp-vinchip--eng' : ''));
      var b = el('b');
      if (tick) { b.appendChild(el('span', 'fp-tick', '✓ ')); }
      b.appendChild(document.createTextNode(main));
      c.appendChild(b);
      if (sub) c.appendChild(el('i', '', sub));
      return c;
    }
    function note(kind, text) {
      return el('div', 'fp-vinnote fp-vinnote--' + kind, text);
    }
    function engineChipSub(res) {
      if (res.flags && res.flags.offline) return 'read from the VIN itself';
      var e = res.engine, bits = [];
      if (e && e.child) {
        var m = e.child.match(/\(([A-Z0-9]+)\s+([^)]+)\)\s*$/);
        if (m) { bits.push(m[1]); bits.push(m[2]); }
      } else if (e && e.era) { bits.push(e.era); }
      if (res.hpBand) bits.push(res.hpBand);
      return bits.join(' · ');
    }
    function ctaButton(label, onClick) {
      var b = el('button', 'fp-btn fp-btn--primary fp-btn--block fp-vin-cta', label);
      b.type = 'button';
      b.addEventListener('click', onClick);
      return b;
    }
    function goViaWidget() {
      var go = root.querySelector('[data-fpy-go]');
      if (go && !go.disabled) { go.click(); return true; }
      return false;
    }
    function renderResolved(res) {
      clearVinUi();
      if (!chipsEl) return;
      var t = res.truck, e = res.engine;
      var genSub = '';
      if (res.truckKey) {
        genSub = res.truckKey.replace(((t.make || '') + ' ' + (t.model || '')).trim(), '').trim();
      } else if (res.genHint) { genSub = 'Gen ' + res.genHint; }
      chipsEl.appendChild(chip(
        [t.year, t.make, t.model].filter(Boolean).join(' ') || 'Truck decoded',
        genSub, false, !!res.truckKey));
      if (e) {
        if (e.parent) {
          chipsEl.appendChild(chip('Engine: ' + e.parent, engineChipSub(res), true, !(res.flags && res.flags.offline)));
        } else if (e.other) {
          chipsEl.appendChild(chip(e.other, res.flags && res.flags.bev ? 'no diesel engine' : 'not in our filter list yet', true, false));
        }
      }
    }
    function garageEngine(e) {
      if (!e) return null;
      if (e.parent) return { parent: e.parent, child: e.child || null, era: e.era || null, label: e.parent };
      if (e.other) return { parent: null, child: null, era: null, other: e.other, label: e.other };
      return null;
    }
    function fillYMM(res, done) {
      var tries = 0;
      function attempt() {
        if (!window.FPYMM || !window.FPYMM.data()) {
          if (tries++ < 15) { setTimeout(attempt, 300); return; }
          done({ ok: false, truck: null, unmatched: ['data'] }); return;
        }
        var out = window.FPYMM.setTruck({
          year: res.truck.year, make: res.truck.make, model: res.truck.model,
          engine: garageEngine(res.engine), vin: res.vin, commit: true
        });
        if (ymmMount) {
          Array.prototype.forEach.call(ymmMount.querySelectorAll('select'), function (s) { if (s.value) flash(s); });
        }
        done(out);
      }
      attempt();
    }
    function renderExtra(res, fill) {
      if (!extraEl) return;
      extraEl.innerHTML = '';
      var t = res.truck, e = res.engine;
      var qs = res.questions || [];
      if (res.flags && res.flags.bev) {
        extraEl.appendChild(note('blue',
          ((t.model || 'This truck') + ' Electric: cab, chassis & universal parts apply — diesel engine parts don’t.')));
      } else if (qs.indexOf('engine-unknown') !== -1) {
        var q = el('div', 'fp-vinq');
        q.appendChild(el('p', '', 'We couldn’t read the engine from this VIN. Which engine is in it?'));
        var sel = el('select');
        sel.appendChild(new Option('Not sure — show truck-fit parts only', ''));
        var parents = (window.FPGarage && window.FPGarage.engineParents) || [];
        parents.forEach(function (p) { sel.appendChild(new Option(p, p)); });
        sel.addEventListener('change', function () {
          if (!sel.value) return;
          res.engine = { parent: sel.value, child: null, era: null };
          if (window.FPGarage) window.FPGarage.setActiveEngine(sel.value);
          renderResolved(res);
          renderExtra(res, fill);
        });
        q.appendChild(sel);
        extraEl.appendChild(q);
      } else if (qs.indexOf('truck-not-in-vocab') !== -1) {
        if (e && e.parent) {
          extraEl.appendChild(note('blue',
            'We don’t map ' + (t.make || 'this make') + ' cabs yet — but engine & universal parts for your ' +
            engineShort(e) + ' are covered.'));
          var engUrl = (window.FPYMM && window.FPYMM.buildUrl) ? window.FPYMM.buildUrl(null, e) : '/collections/all';
          extraEl.appendChild(ctaButton('Show ' + engineShort(e) + ' engine parts + universal', function () {
            window.location.href = engUrl;
          }));
        } else {
          extraEl.appendChild(note('blue',
            'This truck isn’t in our catalog map yet — use the dropdowns or browse all parts.'));
          extraEl.appendChild(ctaButton('Browse all parts', function () { window.location.href = '/collections/all'; }));
        }
        return;
      } else if (res.flags && res.flags.offline) {
        extraEl.appendChild(note('amber',
          'Decoded offline from the VIN pattern — engine unverified. Results are correct for the truck; double-check engine parts.'));
      }
      if (res.truckKey && fill && fill.ok) {
        extraEl.appendChild(ctaButton('Open My Garage', function () {
          window.location.href = '/pages/search-by-truck';
        }));
        if (res.engine && res.engine.parent && window.FPYMM && window.FPYMM.buildUrl) {
          var engUrl2 = window.FPYMM.buildUrl(null, res.engine);
          var a = el('a', 'fp-vin-englink', 'Engine parts for your ' + engineShort(res.engine) + ' →');
          a.href = engUrl2;
          extraEl.appendChild(a);
        }
      }
    }
    function handleResolved(vin, res) {
      if (!res || !res.valid) {
        clearVinUi();
        setStatus(res && res.reason === 'format'
          ? 'That doesn’t look like a valid 17-character VIN (letters I, O and Q are never used).'
          : 'Couldn’t read that VIN. Please use the dropdowns.', 'err');
        return;
      }
      lastVin = vin;
      if (res.kind === 'trailer') {
        clearVinUi();
        var tr = res.trailer || {};
        var maps = (window.FPVIN && window.FPVIN.maps()) || {};
        var trec = maps.trailer_recos || {};
        var bodyLabel = (trec.labels || {})[tr.body] || (trec.labels || {}).default || 'trailer';
        var sub = [bodyLabel !== 'trailer' ? bodyLabel : (tr.type || null),
          tr.length ? tr.length + ' ft' : null, tr.axles ? tr.axles + ' axles' : null]
          .filter(Boolean).join(' · ');
        if (chipsEl) chipsEl.appendChild(chip([tr.year, tr.make, 'trailer'].filter(Boolean).join(' '), sub, false, true));
        if (window.FPGarage) {
          window.FPGarage.add({
            type: 'trailer', value: '', make: tr.make || '', model: 'trailer', year: tr.year || '',
            label: [tr.year, tr.make, 'trailer'].filter(Boolean).join(' '),
            body: tr.body || null, length: tr.length || null, vin: res.vin, source: 'vin'
          });
        }
        if (extraEl) {
          extraEl.innerHTML = '';
          /* recommendation rail per body token (Nicolas 2026-07-07: flatbed ->
             straps/tarps/chains/tires) - data-driven from trailer_recos */
          var recos = (trec.recos || {})[tr.body] || (trec.recos || {}).default || [];
          if (recos.length) {
            var rail = el('div', 'fp-vinrecos');
            rail.appendChild(el('p', 'fp-vinrecos__hd', 'Recommended for your ' + bodyLabel + ':'));
            recos.forEach(function (r) {
              var a = el('a', 'fp-vinreco', r.label);
              a.href = '/collections/all?' + r.types.map(function (t) {
                return 'filter.p.product_type=' + encodeURIComponent(t);
              }).join('&');
              rail.appendChild(a);
            });
            extraEl.appendChild(rail);
          }
          /* ONE axle-tag question (grouped options from the frozen spec vocab) */
          var qs = maps.trailer_spec_questions || [];
          if (qs.length) {
            var q = el('div', 'fp-vinq');
            /* grouped select spans brake + suspension families (fp-vin-maps
               trailer_spec_questions) - keep the lead-in accurate to all of them */
            q.appendChild(el('p', '', 'Brake or suspension part? One question — what’s on the axle tag, drum edge, or suspension plate?'));
            var sel = el('select');
            sel.appendChild(new Option('Pick what’s stamped there…', ''));
            qs.forEach(function (fam) {
              var og = document.createElement('optgroup');
              og.label = fam.family;
              fam.values.forEach(function (v) { og.appendChild(new Option(v, v)); });
              sel.appendChild(og);
            });
            sel.appendChild(new Option('Not sure — browse all parts', '__all__'));
            sel.addEventListener('change', function () {
              if (!sel.value) return;
              if (window.FPGarage && sel.value !== '__all__') window.FPGarage.setActiveSpecs([sel.value]);
              window.location.href = sel.value === '__all__' ? '/collections/all'
                : '/collections/all?' + encodeURIComponent('filter.p.m.custom.spec_keys') + '=' + encodeURIComponent(sel.value);
            });
            q.appendChild(sel);
            extraEl.appendChild(q);
          }
          extraEl.appendChild(ctaButton('Open trailer Garage', function () {
            window.location.href = '/pages/search-by-truck';
          }));
        }
        setStatus('Saved to My truck — we’ll match trailer gear everywhere you browse.', 'ok');
        return;
      }
      renderResolved(res);
      setSummary([res.truck.year, res.truck.make, res.truck.model].filter(Boolean).join(' '));
      fillYMM(res, function (fill) {
        /* picker can't represent this truck (make/model/year not in the vocab
           - e.g. any Mack): save an honest make-only garage truck instead, so
           the banner + badges follow the VIN (AMT/clutch parts fit by
           make+year, engine parts by the decoded engine; truck axis silent). */
        if (!res.truckKey && res.truck && (res.truck.make || res.truck.year) && window.FPGarage) {
          window.FPGarage.add({
            make: res.truck.make || '', model: res.truck.model || '', year: res.truck.year || '',
            value: '',
            label: [res.truck.year, res.truck.make, res.truck.model].filter(Boolean).join(' ') || 'My truck',
            engine: garageEngine(res.engine), vin: res.vin, source: 'vin'
          });
        }
        renderExtra(res, fill);
        if (res.truckKey && fill.ok) {
          setStatus('Saved to My truck — the site now checks fit everywhere you browse.', 'ok');
        } else if (!res.truckKey && res.truck && (res.truck.make || res.truck.year)) {
          setStatus('Saved to My truck — this cab isn’t in our picker yet; engine & universal parts match everywhere.', 'ok');
        } else {
          setStatus('', null);
        }
      });
    }

    /* ---------- decode paths ---------- */
    function legacyDecode(vin) {
      setStatus('Decoding VIN…', null);
      if (vinBtn) { vinBtn.disabled = true; }
      fetch('https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVinValues/' + encodeURIComponent(vin) + '?format=json')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (vinBtn) { vinBtn.disabled = false; }
          var res = (d && d.Results && d.Results[0]) || {};
          var yr = (res.ModelYear || '').toString().trim();
          var mk = titleCase(res.Make || '');
          var md = (res.Model || '').toString().trim();
          if (!yr && !mk && !md) { setStatus('Couldn’t read that VIN. Please use the dropdowns.', 'err'); show('truck'); return; }
          lastVin = vin;
          setSummary([yr, mk, md].filter(Boolean).join(' '));
          setStatus('Detected: ' + [yr, mk, md].filter(Boolean).join(' ') + '. Loading the truck finder…', 'ok');
          show('truck');
          tryFill(root, [yr, mk, md]);
        })
        .catch(function () { if (vinBtn) { vinBtn.disabled = false; } setStatus('VIN service is busy — please use the dropdowns.', 'err'); show('truck'); });
    }
    function decodeVin(vin) {
      var mapsUrl = root.getAttribute('data-fp-vin-maps');
      if (!window.FPVIN || !mapsUrl) { legacyDecode(vin); return; }
      setStatus('Decoding VIN…', null);
      clearVinUi();
      if (vinBtn) { vinBtn.disabled = true; }
      window.FPVIN.load(mapsUrl)
        .then(function () { return window.FPVIN.fetchAndResolve(vin); })
        .then(function (res) {
          if (vinBtn) { vinBtn.disabled = false; }
          handleResolved(vin, res);
        })
        .catch(function () {
          if (vinBtn) { vinBtn.disabled = false; }
          legacyDecode(vin);
        });
    }
    /* exact OEM cross lookup — same index + normalization as the smart box
       (sections/fp-vin-search.liquid); miss falls back to full search */
    var OEM = null;
    function oemFlow(raw) {
      var oemUrl = root.getAttribute('data-fp-oem-index');
      var fallback = '/search?q=' + encodeURIComponent(raw) + '&type=product';
      if (!oemUrl) { window.location.href = fallback; return; }
      setStatus('Matching part number…', null);
      clearVinUi();
      if (vinBtn) { vinBtn.disabled = true; }
      var p = OEM ? Promise.resolve(OEM)
        : fetch(oemUrl).then(function (r) { return r.json(); }).then(function (d) { OEM = d; return d; });
      p.then(function (d) {
        if (vinBtn) { vinBtn.disabled = false; }
        var hits = (d.entries || {})[normOem(raw, brandRe(d.brands))] || [];
        if (!hits.length) { window.location.href = fallback; return; }
        setStatus(hits.length + (hits.length === 1 ? ' exact match' : ' exact matches') + ' for ' + raw, 'ok');
        if (!extraEl) return;
        extraEl.innerHTML = '';
        hits.slice(0, 5).forEach(function (idx) {
          var row = ((d.products || [])[idx]) || [];
          var a = el('a', 'fp-oemhit');
          a.href = '/products/' + row[0];
          a.appendChild(el('b', '', row[2] || row[1] || 'View product'));
          a.appendChild(el('span', 'fp-oemhit__sku', 'SKU ' + (row[1] || '—')));
          a.appendChild(el('span', 'fp-oemhit__x', 'Matches ' + raw + ' via cross-reference'));
          extraEl.appendChild(a);
        });
      }).catch(function () {
        if (vinBtn) { vinBtn.disabled = false; }
        window.location.href = fallback;
      });
    }
    function decode() {
      if (!vinInput) return;
      var raw = (vinInput.value || '').trim();
      if (!raw) { setStatus('Enter a 17-character VIN or an OEM part number.', 'err'); return; }
      /* routing mirrors fp-vin-search.liquid run(): 17 clean alnum chars
         (no I/O/Q) -> VIN; >=5 chars incl. a digit -> OEM cross; else err */
      var vinish = raw.toUpperCase().replace(/[\s-]/g, '');
      if (vinish.length === 17 && /^[A-HJ-NPR-Z0-9]+$/.test(vinish)) { vinInput.value = vinish; decodeVin(vinish); return; }
      if (raw.length >= 5 && /\d/.test(raw)) { oemFlow(raw); return; }
      setStatus('That looks too short — enter a full 17-character VIN or a part number (5+ characters).', 'err');
    }
    if (vinBtn) { vinBtn.addEventListener('click', decode); }
    if (vinInput) { vinInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); decode(); } }); }

  }

  /* Legacy fallback: push decoded Year/Make/Model into the FP-YMM picker
     (fp-ymm.js). Retries briefly in case fp-ymm-data.json is still loading. */
  function tryFill(root, values) {
    var tries = 0;
    function attempt() {
      if (!window.FPYMM || !window.FPYMM.data()) {
        if (tries++ < 15) { setTimeout(attempt, 300); }
        return;
      }
      var res = window.FPYMM.setTruck({ year: values[0], make: values[1], model: values[2], commit: true });
      var mount = root.querySelector('.fp-ymm');
      if (mount) {
        Array.prototype.forEach.call(mount.querySelectorAll('select'), function (s) { if (s.value) flash(s); });
      }
      var st = root.querySelector('.fp-vin-status');
      if (res.ok && st) {
        st.textContent = 'Detected: ' + res.truck.label + '. Press "Find parts for my truck".';
        st.className = 'fp-vin-status is-ok';
      } else if (!res.ok && st) {
        st.textContent = 'Decoded, but this truck is not in our catalog yet - try the dropdowns.';
        st.className = 'fp-vin-status is-err';
      }
    }
    attempt();
  }

  function boot() { injectCss(); document.querySelectorAll('.fp-hero').forEach(initHero); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  // Re-init when the theme editor re-renders the section
  document.addEventListener('shopify:section:load', boot);
})();
